import { Avatar, Stack } from '@mui/material';

interface ILogoButton {
  logo: string;
  href: string | undefined;
  ariaLabel: string;
  isDesktop: boolean;
}

export const LogoButton = ({
  logo,
  href,
  ariaLabel,
  isDesktop,
}: ILogoButton) => {
  return (
    <Stack
      component='a'
      href={href}
      direction='column'
      aria-label={ariaLabel}
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
      }}
    >
      <Avatar
        src={logo}
        alt={ariaLabel}
        sx={{
          height: isDesktop ? '46px' : '32px',
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </Stack>
  );
};
